/*
 * @Author: fangchutao
 * @Description: 授权信息配置
 * @Date: 2019-08-20 14:21:13
 * @Last Modified by: fangchutao
 * @Last Modified time: 2019-08-20 14:28:36
 */
const authorized = {
  state: {
    // 点击某一个合同跳转时的row
    rowData: {}
  },
  mutations: {
    SET_ROWDATA: (state, rowData) => {
      state.rowData = rowData
    }
  }
}
export default authorized


// WEBPACK FOOTER //
// ./src/store/modules/authorized.js